import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-legend_dot",
  "use": "icon-legend_dot-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-legend_dot\">\n<rect y=\"7\" width=\"16\" height=\"2\" fill=\"#5B8DB8\" />\n<circle cx=\"8\" cy=\"8\" r=\"4\" fill=\"#5B8DB8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol